import React from "react";
import Navbar from "./Navbar";
import Hero from "./Hero";
import LogoMarquee from "./LogoMarquee";
import ExpertiseSection from "./ExpertiseSection";
import HeoFrameworkVisualizer from "./HeoFrameworkVisualizer";
import CaseStudies from "./CaseStudies";
import CareerTimeline from "./CareerTimeline";
import AuditSimulator from "./AuditSimulator";
import ContactSection from "./ContactSection";
import Footer from "./Footer";

export default function PortfolioPage() {
  return (
    <div className="bg-[#070b14] text-white min-h-screen font-sans selection:bg-[#4f46e5] selection:text-white antialiased overflow-x-hidden">
      {/* Floating navigation */}
      <Navbar />

      <main>
        {/* High-Impact Motion Hero */}
        <Hero />

        {/* Enterprise Brand Logos Marquee */}
        <LogoMarquee />

        {/* 4 Pillars of Search (AEO/GEO, Tech SEO, SaaS Growth, Analytics) */}
        <ExpertiseSection />

        {/* Proprietary HEO Framework Visualizer */}
        <HeoFrameworkVisualizer />

        {/* Real Results & Case Studies (Seismic, MyOperator, Highspot) */}
        <CaseStudies />

        {/* 8+ Years Progression Career Timeline */}
        <CareerTimeline />

        {/* Interactive SEO & AI Search Readiness Check */}
        <AuditSimulator />

        {/* Direct Contact & Consultation Form */}
        <ContactSection />
      </main>

      {/* Sleek Minimalist Footer */}
      <Footer />
    </div>
  );
}
